import { useRef, useState } from 'react';
import type { ScoreState } from '@aiscoreboard/contracts';
import { resetOverlay, sendEvent } from '../lib/api';
import { useT } from '../lib/i18n';

export function RestorationControls({ state, onChanged, disabled = false }: {
  state: ScoreState; onChanged: () => Promise<void>; disabled?: boolean;
}) {
  const t = useT();
  const [busy, setBusy] = useState(false);
  const pending = useRef(false);
  const [error, setError] = useState<string | null>(null);
  const restoring = state.pauseReason === 'foul_and_miss';
  const act = async (call: () => Promise<unknown>) => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true); setError(null);
    try { await call(); await onChanged(); }
    catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    finally { pending.current = false; setBusy(false); }
  };
  if (state.status !== 'in_progress' || !state.paused) return null;
  return <div data-restoration-controls className="grid w-full grid-cols-2 gap-2">
    {restoring && <button type="button"
      className="min-h-11 rounded-2xl px-2 py-1 text-xs font-bold leading-4 text-sys-yellow ring-2 ring-inset ring-sys-yellow/70 bg-sys-yellow/16 disabled:opacity-40"
      disabled={busy || disabled || state.resetOverlay}
      onClick={() => void act(() => resetOverlay(state.matchId))}>{t('match.resetOverlay')}</button>}
    <button type="button"
      className={`min-h-11 rounded-2xl bg-white/10 px-2 py-1 text-xs font-bold leading-4 text-white/85 ring-1 ring-inset ring-white/20 disabled:opacity-40 ${restoring ? '' : 'col-span-2'}`}
      disabled={busy || disabled}
      onClick={() => void act(() => sendEvent(state.matchId, { type: 'table.resumed', source: 'manual' }))}>{t('match.resume')}</button>
    {error && <p role="alert" className="col-span-2 text-sm text-ball-red">{error}</p>}
  </div>;
}
